import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { route as confirmIdentityRoute } from "@faire/web-api/routes/confirm-identity";
import { path as netTermsPath, route as netTermsRoute } from "@faire/web-api/routes/net-terms";
import { route as posRoute } from "@faire/web-api/routes/point-of-sale";
import { route as availableCreditRoute } from "@faire/web-api/routes/retailer/settings/available-credit";
import { route as emailPreferencesRoute } from "@faire/web-api/routes/retailer/settings/email-preferences";
import { route as insiderSettingsRoute } from "@faire/web-api/routes/retailer/settings/insider-membership";
import { route as myAddressesRoute } from "@faire/web-api/routes/retailer/settings/my-addresses";
import { route as myTeamRoute } from "@faire/web-api/routes/retailer/settings/my-team";
import { path as paymentMethodsPath, route as paymentMethodsRoute } from "@faire/web-api/routes/retailer/settings/payment-methods";
import { route as myAccountRoute } from "@faire/web-api/routes/retailer/settings/profile";
import home from "@faire/web-api/routes/support";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { path as orderInvoicePath } from "@faire/web-api/routes/user/account/invoices/invoiceToken";
import { route as paidInvoicesRoute } from "@faire/web-api/routes/user/account/invoices/paid";
import { route as unpaidInvoicesRoute } from "@faire/web-api/routes/user/account/invoices/unpaid";
import { path as getOrdersRoute, QueryParameters as orderRouteQueryParameters } from "@faire/web-api/routes/user/account/orders";
import { path as getOrderDetailsRoute, QueryParameters as orderDetailsRouteQueryParameters } from "@faire/web-api/routes/user/account/orders/orderToken/brandToken";
import { path as getReportOrderItemRoute } from "@faire/web-api/routes/user/account/orders/orderToken/brandToken/report";
import { QueryParameters as createReturnRouteQueryParameters, path as getCreateReturnRoute } from "@faire/web-api/routes/user/account/orders/orderToken/brandToken/return";
import { route as brandReferralsRoute } from "@faire/web-api/routes/user/brand-referrals";
import { route as insiderInfoRoute } from "@faire/web-api/routes/user/insider/info";
export var CheckShipmentStatusCTA = function CheckShipmentStatusCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "0tRSZ/",
      defaultMessage: "Check shipment status"
    }),
    getLink: getLinkForOrderShipmentStatusPage
  };
};
export var ReportItemsCTA = function ReportItemsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "cx4hgC",
      defaultMessage: "Report item(s)"
    }),
    getLink: getLinkForOrderItemReportModal
  };
};
export var RequestExtensionCTA = function RequestExtensionCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "OkkgWB",
      defaultMessage: "Request an extension"
    }),
    getLink: getLinkForRequestReportExtensionModal
  };
};
export var CreateReturnCTA = function CreateReturnCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "7hggPO",
      defaultMessage: [{
        "type": 0,
        "value": "Een retourzending aanmaken"
      }]
    }),
    getLink: getLinkForCreateReturnModal
  };
};
export var ExtendReturnDateCTA = function ExtendReturnDateCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "fHUYVP",
      defaultMessage: "Extend return date"
    }),
    getLink: getLinkForRequestReturnWindowExtensionModal
  };
};
export var RequestDutiesRefundCTA = function RequestDutiesRefundCTA(strictLocalize, articles) {
  return {
    label: strictLocalize({
      id: "xmPm3d",
      defaultMessage: "Request reimbursement"
    }),
    getLink: function getLink(_) {
      var _articles$ImportFeesA;
      return articles !== null && articles !== void 0 && articles.ImportFeesAndDuties.DUTIES_REFUND ? (_articles$ImportFeesA = articles.ImportFeesAndDuties.DUTIES_REFUND) === null || _articles$ImportFeesA === void 0 ? void 0 : _articles$ImportFeesA.atSection("1").getLink() : undefined;
    }
  };
};
export var GoToOrderDetailsCTA = function GoToOrderDetailsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "I+ZJay",
      defaultMessage: "Go to Order Details"
    }),
    getLink: getLinkForOrderDetailsPage
  };
};
export var ManageShippingAddressesCTA = function ManageShippingAddressesCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "LbTZm0",
      defaultMessage: "Manage shipping addresses"
    }),
    getLink: function getLink() {
      return myAddressesRoute;
    }
  };
};
export var GoToAccountSettingsCTA = function GoToAccountSettingsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "kzFvXG",
      defaultMessage: "Go to Account Settings"
    }),
    getLink: function getLink() {
      return myAccountRoute;
    }
  };
};
export var VerifyAccountCTA = function VerifyAccountCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "OGCf22",
      defaultMessage: "Verify account"
    }),
    getLink: function getLink() {
      return confirmIdentityRoute;
    }
  };
};
export var ManageMyTeamCTA = function ManageMyTeamCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "D8J5jC",
      defaultMessage: "Manage my team"
    }),
    getLink: function getLink() {
      return myTeamRoute;
    }
  };
};
export var UpdateEmailPreferencesCTA = function UpdateEmailPreferencesCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "BKJWBE",
      defaultMessage: "Update email preferences"
    }),
    getLink: function getLink() {
      return emailPreferencesRoute;
    }
  };
};
export var ApplyForEoriCTA = function ApplyForEoriCTA(strictLocalize, articles) {
  return {
    label: strictLocalize({
      id: "UycpHn",
      defaultMessage: "Apply for EORI"
    }),
    getLink: function getLink() {
      return articles !== null && articles !== void 0 && articles.ImportFeesAndDuties.EORI ? articlePage(articles.ImportFeesAndDuties.EORI.id) : undefined;
    }
  };
};
export var GoToFairePosCTA = function GoToFairePosCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "1sen+V",
      defaultMessage: "Go to Faire POS"
    }),
    getLink: function getLink() {
      return posRoute;
    }
  };
};
export var ViewOrderInvoiceCTA = function ViewOrderInvoiceCTA(strictLocalize, brandOrder) {
  return {
    label: strictLocalize({
      id: "OuCjQL",
      defaultMessage: "View order invoice"
    }),
    getLink: function getLink() {
      return getLinkForOrderInvoice(brandOrder);
    }
  };
};
export var ViewInvoicesCTA = function ViewInvoicesCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "+UPMG9",
      defaultMessage: "View invoices"
    }),
    getLink: function getLink() {
      return unpaidInvoicesRoute;
    }
  };
};
export var ViewPaidInvoicesCTA = function ViewPaidInvoicesCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "l0ncxp",
      defaultMessage: "View paid invoices"
    }),
    getLink: function getLink() {
      return paidInvoicesRoute;
    }
  };
};
export var ViewNetTermsCTA = function ViewNetTermsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "hqZerj",
      defaultMessage: "View terms"
    }),
    getLink: function getLink() {
      return netTermsRoute;
    }
  };
};
export var RequestCreditLimitIncreaseCTA = function RequestCreditLimitIncreaseCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "0R+ccx",
      defaultMessage: [{
        "type": 0,
        "value": "Verhoging van kredietlimiet aanvragen"
      }]
    }),
    getLink: function getLink() {
      return netTermsPath({
        limitIncrease: "1"
      });
    }
  };
};
export var AddPaymentMethodCTA = function AddPaymentMethodCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "+EIson",
      defaultMessage: [{
        "type": 0,
        "value": "Betaalmethode toevoegen"
      }]
    }),
    getLink: function getLink() {
      return paymentMethodsPath({
        addModal: true
      });
    }
  };
};
export var ViewOrUpdatePaymentMethodsCTA = function ViewOrUpdatePaymentMethodsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "nBZmWg",
      defaultMessage: [{
        "type": 0,
        "value": "Betaalmethoden bekijken of bijwerken"
      }]
    }),
    getLink: function getLink() {
      return paymentMethodsRoute;
    }
  };
};
export var GoToBrandReferralsCTA = function GoToBrandReferralsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "xkyzAF",
      defaultMessage: "Go to Brand Referrals"
    }),
    getLink: function getLink() {
      return brandReferralsRoute;
    }
  };
};
export var CheckAvailableCreditCTA = function CheckAvailableCreditCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "u08Evv",
      defaultMessage: "Check available credit"
    }),
    getLink: function getLink() {
      return availableCreditRoute;
    }
  };
};
export var ViewOfferDetailsCTA = function ViewOfferDetailsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "PaI1h+",
      defaultMessage: "View offer details"
    }),
    getLink: function getLink() {
      return availableCreditRoute;
    }
  };
};
export var InsiderBenefitsLearnMoreCTA = function InsiderBenefitsLearnMoreCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "TdTXXf",
      defaultMessage: [{
        "type": 0,
        "value": "Meer informatie"
      }]
    }),
    getLink: function getLink() {
      return insiderInfoRoute;
    }
  };
};
export var GoToMembershipSettingsCTA = function GoToMembershipSettingsCTA(strictLocalize) {
  return {
    label: strictLocalize({
      id: "FZoHT0",
      defaultMessage: "Go to Membership Settings"
    }),
    getLink: function getLink() {
      return insiderSettingsRoute;
    }
  };
};
var getLinkForOrderItemReportModal = function getLinkForOrderItemReportModal(brandOrder) {
  var selectedBrandOrder = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.brand_order;
  var orderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.order_token;
  var orderNumber = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.order_number;
  var brandToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_token;
  if (!orderToken && !orderNumber || !brandToken) {
    return home();
  }
  var orderId = orderToken !== null && orderToken !== void 0 ? orderToken : "o_".concat(orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.toLowerCase());
  return getReportOrderItemRoute(orderId, brandToken);
};
var getLinkForOrderShipmentStatusPage = function getLinkForOrderShipmentStatusPage(brandOrder) {
  var orderNumber = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.order_number;
  return orderNumber ? getOrdersRoute(orderRouteQueryParameters.build({
    query: orderNumber
  })) : home();
};
var getLinkForRequestReportExtensionModal = function getLinkForRequestReportExtensionModal() {
  return getOrdersRoute(orderRouteQueryParameters.build({
    action: "request-report-issue"
  }));
};
var getLinkForCreateReturnModal = function getLinkForCreateReturnModal(brandOrder) {
  var selectedBrandOrder = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.brand_order;
  var orderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.order_token;
  var orderNumber = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.order_number;
  var brandToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_token;
  var brandOrderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.token;
  if (!orderToken && !orderNumber || !brandToken || !brandOrderToken) {
    return home();
  }
  var orderId = orderToken !== null && orderToken !== void 0 ? orderToken : "o_".concat(orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.toLowerCase());
  return getCreateReturnRoute(orderId, brandToken, createReturnRouteQueryParameters.build({
    brandOrderToken: brandOrderToken
  }));
};
var getLinkForRequestReturnWindowExtensionModal = function getLinkForRequestReturnWindowExtensionModal() {
  return getOrdersRoute(orderRouteQueryParameters.build({
    action: "extend-cancel-window"
  }));
};
var getLinkForOrderDetailsPage = function getLinkForOrderDetailsPage(brandOrder) {
  var selectedBrandOrder = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.brand_order;
  var orderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.order_token;
  var orderNumber = brandOrder === null || brandOrder === void 0 ? void 0 : brandOrder.order_number;
  var brandToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_token;
  var brandOrderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.token;
  if (!orderToken && !orderNumber || !brandToken || !brandOrderToken) {
    return home();
  }
  var orderId = orderToken !== null && orderToken !== void 0 ? orderToken : "o_".concat(orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.toLowerCase());
  return getOrderDetailsRoute(orderId, brandToken, orderDetailsRouteQueryParameters.build({
    brandOrderToken: brandOrderToken
  }));
};
var getLinkForOrderInvoice = function getLinkForOrderInvoice(brandOrder) {
  var _brandOrder$brand_ord;
  var orderToken = brandOrder === null || brandOrder === void 0 ? void 0 : (_brandOrder$brand_ord = brandOrder.brand_order) === null || _brandOrder$brand_ord === void 0 ? void 0 : _brandOrder$brand_ord.token;
  if (!orderToken) {
    return unpaidInvoicesRoute;
  }
  return orderInvoicePath(orderToken);
};